import type { ReleasePackage } from '../../cataloglifecycle/framework';
import { cn } from '../../lib/cn';
import { Card } from '../ui';

type Props = { releases?: ReleasePackage[] };

function statusColor(status: string) {
  switch (status) {
    case 'approved': return 'bg-brand-100 text-brand-700 dark:bg-brand-950 dark:text-brand-300';
    case 'publishing': return 'bg-warning-100 text-warning-700 dark:bg-warning-950 dark:text-warning-300';
    case 'completed': return 'bg-success-100 text-success-700 dark:bg-success-950 dark:text-success-300';
    default: return 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400';
  }
}

export function ReleasePackageCard({ releases = [] }: Props) {
  return (
    <div className="space-y-3">
      {releases.map((rel) => (
        <Card key={rel.code} padding="sm">
          <div className="flex items-start justify-between">
            <div>
              <p className="font-mono text-sm font-semibold">{rel.code}</p>
              <p className="mt-0.5 text-xs text-slate-500">{rel.items} items · {rel.scheduled}</p>
            </div>
            <span className={cn('rounded-full px-2 py-0.5 text-xs font-medium capitalize', statusColor(rel.status))}>
              {rel.status}
            </span>
          </div>
          <div className="mt-2 flex flex-wrap gap-1">
            {rel.marketplaces.map((m) => (
              <span key={m} className="rounded border border-slate-200 px-1.5 py-0.5 text-xs dark:border-slate-700">{m}</span>
            ))}
          </div>
        </Card>
      ))}
    </div>
  );
}
